import React from 'react';
import * as Fa from 'react-icons/fa';

const MenuRoute = [
  {
    title: 'Dashboard',
    path: '/',
    icon: <Fa.FaHome size={18} />,
    isActive: '',
    action: ['read_only'],
    service: ['nvo.tms.delivery', 'nvo.tms.manifest'],
    isMaster: false,
    isDropdown: false,
  },
  {
    title: 'Account Payable',
    isActive: 'ap',
    icon: <Fa.FaClipboardList size={18} />,
    isMaster: false,
    isDropdown: true,
    child: [
      {
        title: 'Payable',
        path: '/payable',
        isActive: 'ap_payable',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
    ],
  },
  {
    title: 'Account Receivable',
    isActive: 'ar',
    icon: <Fa.FaClipboardList size={18} />,
    isMaster: false,
    isDropdown: true,
    child: [
      {
        title: 'Invoices',
        path: '/receivable',
        isActive: 'ar_receivable',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Laporan Receivable',
        path: '/report/receivable',
        isActive: 'report_receivable',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Monitoring Routine',
        path: '/report/monitoring',
        isActive: 'monitoring',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Outstanding',
        path: '/report/outstanding',
        isActive: 'outstanding',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Omset Customer',
        path: '/report/receivable/customer',
        isActive: 'receivable_customer',
        icon: <Fa.FaRegFileAlt size={16} />,
      }
    ],
  },
  {
    title: 'Quotation',
    path: '/quotation',
    icon: <Fa.FaRegFileAlt size={18} />,
    isActive: 'quotation',
    action: ['read_only'],
    service: ['nvo.marketing.quotation'],
    isMaster: false,
    isDropdown: false,
  },
  {
    title: 'Accounting',
    isActive: 'accounting',
    icon: <Fa.FaClipboardList size={18} />,
    isMaster: false,
    isDropdown: true,
    child: [
      {
        title: 'Journal',
        path: '/accounting/journal',
        isActive: 'accounting_journal',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Tutup Buku',
        path: '/accounting/closing',
        isActive: 'accounting_closing',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Buku Besar',
        path: '/accounting/ledger',
        isActive: 'accounting_ledger',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Neraca',
        path: '/accounting/balancesheet',
        isActive: 'accounting_balancesheet',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Laba Rugi',
        path: '/accounting/profitandloss',
        isActive: 'accounting_profitandloss',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Coa',
        path: '/accounting/coa',
        isActive: 'accounting_coa',
        icon: <Fa.FaRegFileAlt size={16} />,
      },
      {
        title: 'Transaction',
        path: '/accounting/transaction',
        isActive: 'accounting_transaction',
        icon: <Fa.FaRegFileAlt size={16} />,
      }
    ],
  },
  {
    title: 'Master Data',
    path: '',
    icon: <Fa.FaLayerGroup size={18} />,
    isActive: 'master',
    isDropdown: true,
    isMaster: true,
    child: [
      {
        title: 'Customer',
        path: '/master/customer',
        isActive: 'customer',
      },
      {
        title: 'Produk',
        path: '/master/product',
        isActive: 'product',
      },
      {
        title: 'Project',
        path: '/master/project',
        isActive: 'project',
      },
    ],
  },
];

export default MenuRoute;
